export default __webpack_public_path__ + "static/media/logoOnboardingError.f8c3976d.png";